module.exports = __webpack_public_path__ + "static/img/PrestationSoin1.6450650.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PrestationSoin1.jpeg
// module id = u1z9
// module chunks = 1